import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { searchAdsFilterFilter } from "app/filters/ngFilters";
import { trackEvent } from "../SWReactTableTrackEvent";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { useCurrentStateAndParams } from "@uirouter/react";
import DurationService, { customRangeFormat } from "app/services/DurationService";

export const WwoKeywordCell: FC<ITableCellProps> = ({ value, tableOptions, row }) => {
    const { params } = useCurrentStateAndParams();
    const { duration } = params;
    const { raw } = DurationService.getDurationData(duration);
    const dateString = raw.to.format(customRangeFormat);

    const renderLink = () => {
        if (tableOptions.renderTextInsteadOfLinks) {
            return (
                <div className="swTable-content-large">
                    <div className="u-truncate">{value}</div>
                </div>
            );
        }

        return (
            <a
                href={proNavigator.href("organicsearch_keywordAnalysis_overview_2", {
                    ...proNavigator.getParams(),
                    keyword: value,
                    duration: `${dateString}-${dateString}`,
                })}
                className="swTable-content-large"
            >
                <div
                    className="u-truncate"
                    onClick={() => {
                        trackEvent(tableOptions, "Internal Link", `Table/${value}`, "click");
                    }}
                >
                    {value}
                </div>
            </a>
        );
    };

    return (
        <div className="wwo-keyword-cell">
            {renderLink()}
            <a
                href={`https://google.com/search?q=${value}`}
                className="magnifySearch sw-btn-search-press"
                target="_blank"
                rel="noreferrer"
            />
            <a
                className="btn-search-ads"
                href={searchAdsFilterFilter(proNavigator, row.linkState)(value)}
                target="_self"
            >
                Ads
            </a>
        </div>
    );
};
WwoKeywordCell.displayName = "WwoKeywordCell";
